export default "__VITE_ASSET__CNajAzV1__"